import React, {useRef} from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import "./style.scss"

const RawDatasetsTable = ({data}: { data: { columns: string[], content: Array<any> } }) => {
    const dt = useRef<DataTable>(null);
    const maxDatasetPerPage: number = 15;

    const exportCSV = () => {
        dt.current?.exportCSV({selectionOnly: false});
    }

    return <div className={"flex flex-column gap-2"}>

        <Button type="button"
                icon="pi pi-file"
                onClick={exportCSV}
                className="ml-auto p-button-sm"
                data-pr-tooltip="CSV"
                label={"CSV"}
        />
        <div className="w-full h-full">
            <DataTable
                value={data.content}
                paginator={data.content?.length > maxDatasetPerPage}
                responsiveLayout="scroll"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                rows={maxDatasetPerPage}
                size="small"
                scrollable
                ref={dt}
            >
                <Column header={"Date"} field={"timestamp"}/>
                {
                    data.columns.map((key) => {
                        return <Column key={key} field={key} header={key} body={e => e[key] ? e[key] : "-"}/>;
                    })
                }
            </DataTable>
        </div>
    </div>
};

export default RawDatasetsTable;
